<script lang="ts">
  import { SecurityFindingKind } from "$lib/models/base";
  import { toTitleCase } from "$lib/utils/text";
  import * as Select from "$ui/select";
  import { sortBy } from "lodash";

  export const {
    selectAll = false,
    onChange,
    value,
    options = [],
    placeholder,
    sameWidth = true,
    disabled = false,
  }: {
    selectAll?: boolean;
    placeholder?: string;
    value?: SecurityFindingKind;
    options?: SecurityFindingKind[];
    sameWidth?: boolean;
    onChange?: (kind: SecurityFindingKind | null) => void;
    disabled?: boolean;
  } = $props();
  const sortedOptions = $derived(sortBy(Object.values(options)));
</script>

<div class="min-w-[8rem]">
  <Select.Root
    onSelectedChange={(selectedKind) => {
      console.log(`[FindingKindSelect] Selected kind:`, selectedKind);
      if (selectAll && selectedKind?.value === "all") {
        onChange && onChange(null);
      } else {
        onChange && onChange(selectedKind?.value as SecurityFindingKind);
      }
    }}
    {disabled}
  >
    <Select.Trigger name="alias">
      <Select.Value placeholder={toTitleCase(value || placeholder || "No Kind")} />
    </Select.Trigger>
    <Select.Content {sameWidth}>
      <Select.Group>
        {#if selectAll}
          <Select.Item value="all" label={placeholder} isSelected={!value}>
            {placeholder}
          </Select.Item>
        {/if}
        {#each sortedOptions as findingKind}
          <Select.Item
            value={findingKind.toString().toLowerCase()}
            label={toTitleCase(findingKind.toString())}
            isSelected={findingKind.toString().toLowerCase() === value?.toString().toLowerCase()}
          >
            {toTitleCase(findingKind.toString())}
          </Select.Item>
        {/each}
      </Select.Group>
    </Select.Content>
  </Select.Root>
</div>
